import { CardEnum } from '@colonist/game-states';
export const CARD_STACK_SIZES_1 = Object.keys(CardEnum).reduce((acc, cardEnumKeyOrValue)=>{
    const cardEnum = Number(cardEnumKeyOrValue);
    if (isNaN(cardEnum)) return acc;
    acc[cardEnum] = 1;
    return acc;
}, {});
